import history from '../../../app/history';
import axios from 'axios';
import { auth } from '../../../api/auth';
import { toastr } from 'react-redux-toastr';
import { store } from '../../storeConfig/store';
import {api} from "../../../api/api";

export const setLoginFlag = (value) => {
  return {
    type: 'SET_LOGIN_FLAG',
    payload: { data: value },
  };
};


export const loginWithJWT = (user) => {
  return async (dispatch) => {
    // console.log(user);
    let response = await auth('/login', user, 'post');
    //             // console.log(response.data.data[0].role);
    if (response && response.data.data) {
      let loggedInUser = response.data.data;
      console.log(loggedInUser);
      if (!loggedInUser.isEnabled) {
        toastr.error('Login Restricted. Please Contact Admin');
        return;
      }
      dispatch({
        type: 'LOGIN_WITH_JWT',
        payload: { loggedInUser, loggedInWith: 'jwt' },
      });
      dispatch({
        type: 'SET_LOGIN_FLAG',
        payload: { data: true },
      });
      switch (loggedInUser.role) {
        case 'admin':
          dispatch({
            type: 'CHANGE_ROLE',
            payload: { data: 'A' },
          });
          break;
        default:
          dispatch({
            type: 'CHANGE_ROLE',
            payload: { data: 'C' },
          });
          api(
            `/accountFromSyspro/${loggedInUser.account.id}`,
            {},
            'patch'
          );
      }
      // dispatch({
      //   type: "CHANGE_ROLE",
      //   payload: { data: "A" },
      // });
      localStorage.setItem('user', JSON.stringify(loggedInUser));
      localStorage.setItem('firstTimeLoggedIn', true);
      // history.push("/")
      toastr.success('Login Successful');
      history.push('/home');
    } else {
      dispatch({
        type: 'LOGIN_WITH_JWT',
        payload: {},
      });
      toastr.error('Invalid Credentials');
      history.push('/');
    }
  };
  //   })
  //   .catch(err => console.log(err))
  // };
};

export const logoutWithJWT = () => {
  return async (dispatch) => {
    let isLoggedIn = store.getState().auth.login;
    let id = isLoggedIn.values.loggedInUser.id;
    let response = await auth(`/logout/${id}`, {}, 'get');
    // console.log('response', response);
    history.push('/');

    // console.log('id', id);
    dispatch({
      type: 'SET_LOGIN_FLAG',
      payload: { data: false },
    });
    dispatch({
      type: 'CHANGE_ROLE',
      payload: { data: '' },
    });
    dispatch({ type: 'LOGOUT_WITH_JWT', payload: {} });

    localStorage.removeItem('user');
    toastr.success('Logout Successful');
  };
};

export const logoutWithFirebase = (user) => {
  return (dispatch) => {
    dispatch({ type: 'LOGOUT_WITH_FIREBASE', payload: {} });
    dispatch({
      type: 'SET_LOGIN_FLAG',
      payload: { data: false },
    });
    dispatch({
      type: 'CHANGE_ROLE',
      payload: { data: '' },
    });
    localStorage.removeItem('user');
    toastr.success('Logout Successful');
    history.push('/');
  };
};

export const changeRole = (role) => {
  return (dispatch) => dispatch({ type: 'CHANGE_ROLE', userRole: role });
};
